import React from 'react';
import { Checkbox as CheckboxComponent } from '../../../../../Checkbox';

interface CellWithCheckboxProps {
  checked?: boolean;
  checkedSome?: boolean;
  onToggle?: (value?: boolean) => void;
}

export const Checkbox: React.FC<CellWithCheckboxProps> = ({ checked, onToggle, checkedSome }) => {
  return (
    <CheckboxComponent
      style={{ margin: 0 }}
      slotProps={{ input: { style: { margin: 0 } } }}
      checked={checked}
      dashStyle={checkedSome}
      onChange={() => onToggle?.(!checked)}
    />
  );
};
